import React, { useState } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import "../styles/SuggestPromptModal.scss";

interface SuggestPromptModalProps {
  suggestPromptModal: boolean;
  setSuggestPromptModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const SuggestPromptModal: React.FC<SuggestPromptModalProps> = ({
  suggestPromptModal,
  setSuggestPromptModal,
}) => {
  const [submit, setSubmit] = useState(false);

  return (
    <Modal
      size="sm"
      style={{ maxWidth: "471px" }}
      isOpen={suggestPromptModal}
      className="SuggestPromptModal modal-dialog-centered"
    >
      <ModalBody className="p-0">
        <>
          <img
            style={{ position: "absolute", right: "-30px", top: "-30px" }}
            src={require("@src/assets/images/vyrill/cross.png").default}
            alt=""
            role="button"
            width="30px"
            className="closeBtn"
            onClick={() => {
              setSuggestPromptModal(false);
            }}
          />
          {submit ? (
            <div className="pb-2">
              <div className="text-center mb-1 mt-2">
                <img
                  src={
                    require("@src/assets/images/vyrill/suggestion-icon.png")
                      .default
                  }
                  alt=""
                  role="button"
                  width="30px"
                />
              </div>
              <div className="value-suggestion">We value your suggestion!</div>
              <div className="value-message">
                Our team will thoroughly look into the prompt and carefully
                consider its potential.
              </div>
            </div>
          ) : (
            <div>
              <div className="text-container">
                <textarea
                  className="flag-reason-container"
                  name="customNote"
                  placeholder={`Suggest the prompt that you would like to see in “Ask Vyrill” section.`}
                />
                <div className="text-center">
                  {" "}
                  <Button
                    className="submit-btn"
                    size="lg"
                    onClick={() => setSubmit(true)}
                    color="primary"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          )}
        </>
      </ModalBody>
    </Modal>
  );
};

export default SuggestPromptModal;
